import { CMSAllocation } from "@components/V2/Vault/Common/VaultAprReports";
import { ReactNode, createContext } from "react";

interface IData {
  cmsAllocations: {
    allocations: CMSAllocation[];
  } | null;
}
const initialData: IData = {
  cmsAllocations: null,
};

export const AirdropVaultPageContext = createContext(initialData);

interface IProps {
  children: ReactNode;
  data: IData;
}

export const AirdropVaultProvider = ({ data, children }: IProps) => {
  return (
    <AirdropVaultPageContext.Provider value={data}>
      {children}
    </AirdropVaultPageContext.Provider>
  );
};

export { type IData as PageContextData };
